/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Currency } from './Currency';
import {
    CurrencyFromJSON,
    CurrencyFromJSONTyped,
    CurrencyToJSON,
} from './Currency';
import type { Price } from './Price';
import {
    PriceFromJSON,
    PriceFromJSONTyped,
    PriceToJSON,
} from './Price';

/**
 * Representation of a Voucher
 * @export
 * @interface Voucher
 */
export interface Voucher {
    /**
     * The identifier of the Voucher. This is the first part of voucher code which holds first 3 letters, like: 123
     * @type {string}
     * @memberof Voucher
     */
    code?: string;
    /**
     * Voucher code, is the holder for keeping specific occasional voucher related to business usage. It can be generated and looks like: 123-H8BC-Y3D5-34AL
     * @type {string}
     * @memberof Voucher
     */
    voucherCode?: string;
    /**
     * Name of the voucher
     * @type {string}
     * @memberof Voucher
     */
    name?: string;
    /**
     * Description of the voucher
     * @type {string}
     * @memberof Voucher
     */
    description?: string;
    /**
     * Value of the voucher. Example of such value is: 15.0d
     * @type {number}
     * @memberof Voucher
     */
    value?: number;
    /**
     * Formatted value of the voucher
     * @type {string}
     * @memberof Voucher
     */
    valueFormatted?: string;
    /**
     * The value of the voucher to display. Example: 15.0%
     * @type {string}
     * @memberof Voucher
     */
    valueString?: string;
    /**
     * Specifies if the order this voucher is applied to is shipped for free (true) or not (false). Defaults to false.
     * @type {boolean}
     * @memberof Voucher
     */
    freeShipping?: boolean;
    /**
     * 
     * @type {Currency}
     * @memberof Voucher
     */
    currency?: Currency;
    /**
     * 
     * @type {Price}
     * @memberof Voucher
     */
    appliedValue?: Price;
    /**
     * Indicates whether the voucher was accepted by the pricing engine. When true, the discount is applied. When false, the voucher is rejected, with possible reasons of: expired, already used, not applicable. When null, no pricing engine verdict is available (standard SAP Commerce behavior).
     * @type {boolean}
     * @memberof Voucher
     */
    sapAccepted?: boolean;
}

/**
 * Check if a given object implements the Voucher interface.
 */
export function instanceOfVoucher(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function VoucherFromJSON(json: any): Voucher {
    return VoucherFromJSONTyped(json, false);
}

export function VoucherFromJSONTyped(json: any, ignoreDiscriminator: boolean): Voucher {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': !exists(json, 'code') ? undefined : json['code'],
        'voucherCode': !exists(json, 'voucherCode') ? undefined : json['voucherCode'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'value': !exists(json, 'value') ? undefined : json['value'],
        'valueFormatted': !exists(json, 'valueFormatted') ? undefined : json['valueFormatted'],
        'valueString': !exists(json, 'valueString') ? undefined : json['valueString'],
        'freeShipping': !exists(json, 'freeShipping') ? undefined : json['freeShipping'],
        'currency': !exists(json, 'currency') ? undefined : CurrencyFromJSON(json['currency']),
        'appliedValue': !exists(json, 'appliedValue') ? undefined : PriceFromJSON(json['appliedValue']),
        'sapAccepted': !exists(json, 'sapAccepted') ? undefined : json['sapAccepted'],
    };
}

export function VoucherToJSON(value?: Voucher | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'code': value.code,
        'voucherCode': value.voucherCode,
        'name': value.name,
        'description': value.description,
        'value': value.value,
        'valueFormatted': value.valueFormatted,
        'valueString': value.valueString,
        'freeShipping': value.freeShipping,
        'currency': CurrencyToJSON(value.currency),
        'appliedValue': PriceToJSON(value.appliedValue),
        'sapAccepted': value.sapAccepted,
    };
}

